import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { CompanyProfile } from 'models';
import { EventHelpers } from 'helpers/EventHelpers';

import { useEvents } from 'hooks/use-events';

const useCompanyEvent = (company: Pick<CompanyProfile, 'id'>) => {
    const { events, isLoading } = useEvents();

    const [event] = EventHelpers.sortByStart(
        events.filter(
            (candidate) =>
                EventHelpers.isCurrentOrUpcoming(candidate) &&
                CollectionHelpers.find(candidate.companies, company.id, 'company'),
        ),
    );

    const booth = event ? CollectionHelpers.find(event.companies, company.id, 'company')?.booth : undefined;

    return { event, booth, isLoading };
};

export { useCompanyEvent };
